import Link from 'next/link';
import { authorPath, webUrl } from 'utils/news-article-schema';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

export const authorRole = (author) =>
    !author.isOrganization && author.jobTitle
        ? `${author.jobTitle}, Newspage`
        : null;

// Who wrote the story, under it; on their own page (onPage) it heads the page.
const AuthorBlock = ({ author, onPage = false }) => {
    const photo = webUrl(author.photoUrl);
    const linkedin = webUrl(author.linkedinUrl);
    const role = authorRole(author);
    const href = authorPath(author.slug);
    const Name = onPage ? 'h1' : 'p';

    return (
        <section
            className={[styles.authorBlock, !onPage && styles.authorFoot]
                .filter(Boolean)
                .join(' ')}
            aria-label={onPage ? undefined : 'About the author'}
        >
            {photo && (
                <img
                    className={styles.authorPhoto}
                    src={photo}
                    alt={author.name}
                    width={96}
                    height={96}
                />
            )}
            <div>
                <Name className={styles.authorName}>
                    {onPage ? (
                        author.name
                    ) : (
                        <Link href={href}>
                            <a>{author.name}</a>
                        </Link>
                    )}
                </Name>
                {role && <p className={styles.authorRole}>{role}</p>}
                {author.bio && <p className={styles.authorBio}>{author.bio}</p>}
                <p className={styles.authorLinks}>
                    {!onPage && (
                        <Link href={href}>
                            <a>More from {author.name}</a>
                        </Link>
                    )}
                    {linkedin && (
                        <a href={linkedin} target="_blank" rel="noopener">
                            LinkedIn
                        </a>
                    )}
                </p>
            </div>
        </section>
    );
};

export default AuthorBlock;
